import { Loading, PageHeader, Table, useAdminGet } from "@/components/admin/ui";

export const Prestations = ({ openSessions }) => {
  const [rows] = useAdminGet("/admin/hub/prestations");
  if (!rows) return <Loading />;
  return (
    <div data-testid="admin-prestations">
      <PageHeader title="Prestations" />
      <Table testid="admin-prestations-table" cols={["Prestation", "Sessions à venir", "Sessions passées", "Annulées"]} empty="Aucune prestation."
        onRow={(i) => openSessions(rows[i].type)}
        rows={rows.map((r) => [<span className="text-bark" data-testid={`admin-prestation-${r.type}`}>{r.label}</span>, <strong>{r.sessions_a_venir}</strong>, r.sessions_passees, r.annulees])} />
    </div>
  );
};
